import React  from 'react'
const CnC = () => {
    return (
        <div className="pb-10 text-white font-sant-serif poppins">
            <ul className="list-disc list-inside">
                <li className="leading-8 my-3">Respect for Others : All participants, organizers, and attendees must show respect towards each other, regardless of background, culture, gender, or any other individual differences. Mutual respect is the foundation of our fest, and any form of disrespect will not be tolerated. 
</li>
                <li className="leading-8 my-3">Ethical Behavior : Participants are expected to uphold the highest standards of ethical behavior in all competitions and academic events. Cheating, plagiarism, or any form of unethical conduct will result in immediate disqualification and further consequences. 

                </li>
                <li className="leading-8 my-3">Safety First : Participants must prioritize their own safety and the safety of others during all events. Any actions that pose a risk of harm to individuals or property are strictly prohibited. 

                </li>
                <li className="leading-8 my-3">No Discrimination : Discrimination of any kind, including but not limited to race, ethnicity, gender, religion, or sexual orientation, is strictly prohibited. Any participant found engaging in discriminatory behavior will be disqualified from the event and may face additional action. 

                </li>
                <li className="leading-8 my-3">No Substance Abuse : The use of drugs or alcohol is strictly prohibited during the fest. Any participant found under the influence or in possession of drugs or alcohol will be immediately removed from the event. 

                </li>
                <li className="leading-8 my-3">Respect for Property : All participants, organizers, and attendees must respect the property of AIIMS Rishikesh and others. Any damage to property will lead to disqualification, and the responsible participant will be held accountable for repair or replacement costs. 


                </li>
                <li className="leading-8 my-3">Fair Play : Fair play is essential in all competitions. Any attempt to manipulate or cheat in any event will not be tolerated. Participants are expected to follow the rules and regulations of each competition to ensure a fair and enjoyable experience for all. 


                </li>
                <li className="leading-8 my-3">No Harassment : Harassment of any kind, whether physical, verbal, or sexual, will not be tolerated. Any participant found engaging in harassment will be immediately disqualified and removed from the event premises. 

                </li>
                <li className="leading-8 my-3">Compliance with the Law : All participants are required to adhere to local laws and regulations during the fest. Any illegal behavior will result in immediate removal from the event and possible legal consequences. 


                </li>
                <li className="leading-8 my-3">Agreement to Code of Conduct : By participating in PYREXIA 2025 (PYREXIA 5.0), all participants, organizers, and attendees agree to abide by this Code of Conduct. AIIMS Rishikesh reserves the right to take any necessary action to ensure compliance, including disqualification from events and removal from the premises.

</li>
            </ul>

        </div>
    );
};
export default CnC;